import { BeelineResult } from '../beelineLp/BeelineLanding';

export default function Beeline2Failed() {
  return <BeelineResult lpKey="beeline2" outcome="failed" variant={2} />;
}
